const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid #8a6a00', fontFamily:"'Georgia', serif", color:'#1a1200', lineHeight:'1.7', background:'#fffdf0' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #d4a000', paddingBottom:'8px', marginBottom:'24px', color:'#7a4f00' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#b88000', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #d4a000', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#fffbe6', border:'2px solid #d4a000', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7a4f00', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #d4a000' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#b88000', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0d98a', verticalAlign:'top', background:'#fffbee' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0d98a', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7a4f00', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffdf5', border:'1px solid #e8c84a', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7a4f00', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#666', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Detail</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram: System Architecture Block Diagram ───────────────────────
function DiagramSystemArch() {
  const W = 900, H = 300;

  const blocks = [
    { label:'Command\nSource', sub:'MCU / PC\nJoystick / CAN', x:30,  y:110, w:120, h:80, color:'#c49000' },
    { label:'Controller\nBoard', sub:'PID / FOC\nlogic', x:200, y:110, w:130, h:80, color:'#d4a000' },
    { label:'Gate\nDriver', sub:'Bootstrap\nIsolation', x:390, y:110, w:110, h:80, color:'#b88000' },
    { label:'Power\nStage', sub:'MOSFET/IGBT\nH-Bridge / Inverter', x:555, y:110, w:130, h:80, color:'#e07b00' },
    { label:'Motor', sub:'DC / BLDC\nAC Induction', x:745, y:110, w:110, h:80, color:'#c49000' },
  ];

  const feedbackBlocks = [
    { label:'Current\nSense', sub:'Shunt / Hall', x:555, y:230, w:130, h:50, color:'#b88000' },
    { label:'Position /\nSpeed Sensor', sub:'Encoder / Resolver', x:390, y:230, w:130, h:50, color:'#b88000' },
  ];

  const arrowMidY = 150;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Motor Controller System Architecture — Signal & Power Flow</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="arrowFwd" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#d4a000"/>
          </marker>
          <marker id="arrowFb" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#b88000"/>
          </marker>
        </defs>

        {/* Power supply rail */}
        <rect x={390} y={20} width={355} height={22} rx={4} fill="#e07b00" opacity="0.85"/>
        <text x={568} y={35} textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff">DC Bus / Power Supply  (12V – 800V)</text>
        <line x1={555+65} y1={42} x2={555+65} y2={110} stroke="#e07b00" strokeWidth="2.5" strokeDasharray="4,2"/>

        {/* Main forward chain blocks */}
        {blocks.map((b, i) => {
          const lines = b.label.split('\n');
          const subs  = b.sub.split('\n');
          return (
            <g key={i}>
              <rect x={b.x} y={b.y} width={b.w} height={b.h} rx={7} fill={b.color} opacity="0.9"/>
              {lines.map((l, li) => (
                <text key={li} x={b.x + b.w/2} y={b.y + 24 + li*16}
                  textAnchor="middle" fontSize="12" fontWeight="700" fill="#fff">{l}</text>
              ))}
              {subs.map((l, li) => (
                <text key={li} x={b.x + b.w/2} y={b.y + 57 + li*13}
                  textAnchor="middle" fontSize="9" fill="#fff9cc">{l}</text>
              ))}
            </g>
          );
        })}

        {/* Forward arrows between blocks */}
        {blocks.slice(0,-1).map((b, i) => (
          <line key={i}
            x1={b.x + b.w} y1={arrowMidY}
            x2={blocks[i+1].x} y2={arrowMidY}
            stroke="#d4a000" strokeWidth="2.5" markerEnd="url(#arrowFwd)"/>
        ))}

        {/* Feedback blocks */}
        {feedbackBlocks.map((b, i) => {
          const lines = b.label.split('\n');
          const subs  = b.sub.split('\n');
          return (
            <g key={i}>
              <rect x={b.x} y={b.y} width={b.w} height={b.h} rx={6} fill={b.color} opacity="0.8"/>
              {lines.map((l, li) => (
                <text key={li} x={b.x + b.w/2} y={b.y + 16 + li*14}
                  textAnchor="middle" fontSize="10" fontWeight="700" fill="#fff">{l}</text>
              ))}
              {subs.map((l, li) => (
                <text key={li} x={b.x + b.w/2} y={b.y + 38 + li*12}
                  textAnchor="middle" fontSize="9" fill="#fff9cc">{l}</text>
              ))}
            </g>
          );
        })}

        {/* Feedback arrows upward from sensor blocks to controller */}
        {/* Current sense → Gate Driver / Controller */}
        <line x1={620} y1={230} x2={620} y2={192} stroke="#b88000" strokeWidth="1.8" markerEnd="url(#arrowFb)"/>
        {/* Encoder → Controller board */}
        <line x1={455} y1={230} x2={320} y2={230} stroke="#b88000" strokeWidth="1.8"/>
        <line x1={265} y1={230} x2={265} y2={192} stroke="#b88000" strokeWidth="1.8" markerEnd="url(#arrowFb)"/>
        <line x1={320} y1={230} x2={265} y2={230} stroke="#b88000" strokeWidth="1.8"/>

        {/* Feedback label */}
        <text x={350} y={248} textAnchor="middle" fontSize="9" fill="#b88000" fontStyle="italic">feedback signals</text>

        {/* Motor shaft arrow (output) */}
        <line x1={855} y1={150} x2={880} y2={150} stroke="#7a4f00" strokeWidth="2.5" markerEnd="url(#arrowFwd)"/>
        <text x={885} y={145} fontSize="9" fill="#7a4f00">τ, ω</text>
        <text x={885} y={157} fontSize="9" fill="#7a4f00">shaft</text>

        {/* Labels: signal vs power path */}
        <rect x={30} y={260} width={160} height={28} rx={3} fill="#fffbe6" stroke="#d4a000"/>
        <text x={38} y={275} fontSize="9" fontWeight="700" fill="#7a4f00">── Control signal path</text>
        <text x={38} y={286} fontSize="9" fill="#b88000">── Feedback path</text>
        <rect x={210} y={260} width={180} height={28} rx={3} fill="#fffbe6" stroke="#e07b00"/>
        <text x={218} y={275} fontSize="9" fontWeight="700" fill="#e07b00">Power flows right →</text>
        <text x={218} y={286} fontSize="9" fill="#888">Gate driver isolates logic from HV</text>
      </svg>
      <div style={S.dCaption}>Every motor controller embodies this same signal chain: command → digital control → gate signals → power switching → motor → feedback</div>
    </div>
  );
}

// ── Diagram: H-Bridge Topology ───────────────────────────────────────
function DiagramHBridge() {
  const W = 900, H = 340;
  const midX = 320, midY = 170;
  const sw = 70, sh = 40; // switch size

  // Four switch positions
  const switches = [
    { label:'Q1', state:'ON',  x: midX-120, y: midY-100, color:'#d4a000' }, // top-left
    { label:'Q2', state:'OFF', x: midX+50,  y: midY-100, color:'#b88000' }, // top-right
    { label:'Q3', state:'OFF', x: midX-120, y: midY+60,  color:'#b88000' }, // bot-left
    { label:'Q4', state:'ON',  x: midX+50,  y: midY+60,  color:'#d4a000' }, // bot-right
  ];

  // Motor in the centre
  const mCx = midX - 10, mCy = midY;

  // Node coordinates
  const topL  = { x: midX-85,  y: midY-60 };
  const topR  = { x: midX+85,  y: midY-60 };
  const botL  = { x: midX-85,  y: midY+60 };
  const botR  = { x: midX+85,  y: midY+60 };
  const vcc   = { x: midX,     y: 28 };
  const gnd   = { x: midX,     y: H-30 };

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>H-Bridge (Full Bridge) — Topology, Switch States, and Current Path</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="arrowH" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#e07b00"/>
          </marker>
        </defs>

        {/* VCC rail */}
        <line x1={midX-120} y1={28} x2={midX+120} y2={28} stroke="#e07b00" strokeWidth="3"/>
        <text x={midX} y={20} textAnchor="middle" fontSize="11" fontWeight="700" fill="#e07b00">V_supply</text>

        {/* GND rail */}
        <line x1={midX-120} y1={H-30} x2={midX+120} y2={H-30} stroke="#555" strokeWidth="3"/>
        <text x={midX} y={H-14} textAnchor="middle" fontSize="11" fontWeight="700" fill="#555">GND</text>

        {/* Left vertical rail */}
        <line x1={midX-85} y1={28} x2={midX-85} y2={H-30} stroke="#888" strokeWidth="1.5"/>
        {/* Right vertical rail */}
        <line x1={midX+85} y1={28} x2={midX+85} y2={H-30} stroke="#888" strokeWidth="1.5"/>

        {/* Switch boxes */}
        {switches.map((sw2, i) => (
          <g key={i}>
            <rect x={sw2.x} y={sw2.y} width={sw} height={sh} rx={5} fill={sw2.color} opacity="0.9"/>
            <text x={sw2.x+sw/2} y={sw2.y+15} textAnchor="middle" fontSize="12" fontWeight="700" fill="#fff">{sw2.label}</text>
            <text x={sw2.x+sw/2} y={sw2.y+30} textAnchor="middle" fontSize="10" fill="#fff9cc">
              {sw2.state==='ON'?'CLOSED ✓':'OPEN'}
            </text>
          </g>
        ))}

        {/* Motor circle */}
        <circle cx={mCx} cy={mCy} r={38} fill="#c49000" opacity="0.9"/>
        <text x={mCx} y={mCy-4} textAnchor="middle" fontSize="13" fontWeight="700" fill="#fff">M</text>
        <text x={mCx} y={mCy+12} textAnchor="middle" fontSize="9" fill="#fff9cc">motor</text>

        {/* Motor connection lines to bridge midpoints */}
        <line x1={mCx-38} y1={mCy} x2={midX-85} y2={mCy} stroke="#d4a000" strokeWidth="2.5"/>
        <line x1={mCx+38} y1={mCy} x2={midX+85} y2={mCy} stroke="#d4a000" strokeWidth="2.5"/>

        {/* Current path highlight — Q1 ON, Q4 ON → current flows left-to-right through motor */}
        <path d={`M ${midX-85},28 L ${midX-85},${mCy-15}`}
          fill="none" stroke="#e07b00" strokeWidth="4" opacity="0.5" markerEnd="url(#arrowH)"/>
        <path d={`M ${midX-85},${mCy+15} L ${midX-85},${H-30}`}
          fill="none" stroke="#555" strokeWidth="4" opacity="0.3"/>
        <path d={`M ${midX+85},${mCy+15} L ${midX+85},${H-30}`}
          fill="none" stroke="#e07b00" strokeWidth="4" opacity="0.5" markerEnd="url(#arrowH)"/>

        {/* Current direction arrow through motor */}
        <line x1={mCx-30} y1={mCy} x2={mCx+30} y2={mCy}
          stroke="#e07b00" strokeWidth="3" markerEnd="url(#arrowH)" opacity="0.8"/>

        {/* Right panel — truth table */}
        <rect x={480} y={30} width={390} height={200} rx={6} fill="#fffbe6" stroke="#d4a000"/>
        <text x={675} y={52} textAnchor="middle" fontSize="13" fontWeight="700" fill="#7a4f00">H-Bridge Truth Table</text>

        {/* Table header */}
        {['Q1','Q2','Q3','Q4','Motor Action'].map((h, i) => (
          <rect key={i} x={488 + i*74} y={58} width={i===4?84:68} height={22} rx={2} fill="#b88000"/>
        ))}
        {['Q1','Q2','Q3','Q4','Motor Action'].map((h, i) => (
          <text key={i} x={488 + i*74 + (i===4?42:34)} y={73} textAnchor="middle"
            fontSize="10" fontWeight="700" fill="#fff">{h}</text>
        ))}

        {/* Table rows */}
        {[
          ['1','0','0','1','Forward (CW)'],
          ['0','1','1','0','Reverse (CCW)'],
          ['1','1','0','0','Brake (short)'],
          ['0','0','1','1','Brake (short)'],
          ['0','0','0','0','Coast (free)'],
          ['1','0','1','0','SHOOT-THROUGH ⚠'],
        ].map((row, ri) => (
          <g key={ri}>
            {row.map((cell, ci) => {
              const isWarn = ri === 5;
              const fill = isWarn ? '#a03000' : (ri%2===0 ? '#fffcf0':'#fff');
              return (
                <g key={ci}>
                  <rect x={488+ci*74} y={80+ri*22} width={ci===4?84:68} height={22} rx={1}
                    fill={fill} stroke="#e8c84a" strokeWidth="0.4"/>
                  <text x={488+ci*74+(ci===4?42:34)} y={80+ri*22+15} textAnchor="middle"
                    fontSize={ci===4?9:10} fill={isWarn?(ci===4?'#fff':'#a03000'):'#1a1200'}
                    fontFamily={ci<4?"'Courier New',monospace":"inherit"}
                    fontWeight={ci===4&&isWarn?'700':'400'}>{cell}</text>
                </g>
              );
            })}
          </g>
        ))}

        {/* Shoot-through warning */}
        <rect x={488} y={214} width={374} height={14} rx={2} fill="#fff0e6" stroke="#a03000"/>
        <text x={675} y={224} textAnchor="middle" fontSize="9" fill="#a03000">
          ⚠ Shoot-through = Q1+Q3 or Q2+Q4 ON simultaneously → dead short across supply
        </text>

        {/* Dead-time annotation */}
        <rect x={488} y={232} width={374} height={14} rx={2} fill="#fffbe6" stroke="#d4a000"/>
        <text x={675} y={242} textAnchor="middle" fontSize="9" fill="#7a4f00">
          Dead-time: mandatory delay (50ns–2µs) between turning one switch OFF and the other ON
        </text>
      </svg>
      <div style={S.dCaption}>Q1=high-side left, Q2=high-side right, Q3=low-side left, Q4=low-side right. Body diodes provide freewheeling during switching.</div>
    </div>
  );
}

// ── Diagram: Three-Phase Inverter ────────────────────────────────────
function DiagramThreePhase() {
  const W = 900, H = 310;
  const phases = ['U (A)','V (B)','W (C)'];
  const colors = ['#d4a000','#e07b00','#b88000'];
  const phaseX = [200, 380, 560];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Three-Phase Voltage Source Inverter (VSI) — 6-Switch Topology</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="arrowTP" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#d4a000"/>
          </marker>
        </defs>

        {/* DC Bus rails */}
        <rect x={100} y={18} width={520} height={22} rx={4} fill="#e07b00" opacity="0.9"/>
        <text x={360} y={33} textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff">DC Bus  +V_dc</text>
        <rect x={100} y={260} width={520} height={22} rx={4} fill="#555" opacity="0.85"/>
        <text x={360} y={275} textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff">DC Bus  GND (0V)</text>

        {/* DC capacitor */}
        <rect x={50} y={80} width={34} height={120} rx={3} fill="#c49000" opacity="0.7"/>
        <text x={67} y={136} textAnchor="middle" fontSize="9" fill="#fff" fontWeight="700">C_dc</text>
        <text x={67} y={148} textAnchor="middle" fontSize="8" fill="#fff9cc">bulk</text>
        <line x1={67} y1={40} x2={67} y2={80} stroke="#e07b00" strokeWidth="2"/>
        <line x1={67} y1={200} x2={67} y2={260} stroke="#555" strokeWidth="2"/>
        <line x1={84} y1={40} x2={100} y2={40} stroke="#e07b00" strokeWidth="2"/>
        <line x1={84} y1={270} x2={100} y2={270} stroke="#555" strokeWidth="2"/>

        {/* Phase legs */}
        {phases.map((ph, i) => {
          const x = phaseX[i];
          const col = colors[i];
          return (
            <g key={i}>
              {/* Vertical rail */}
              <line x1={x} y1={40} x2={x} y2={260} stroke="#ccc" strokeWidth="1.5"/>

              {/* High-side switch */}
              <rect x={x-30} y={55} width={60} height={38} rx={5} fill={col} opacity="0.9"/>
              <text x={x} y={71} textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff">Q{i*2+1}</text>
              <text x={x} y={85} textAnchor="middle" fontSize="9" fill="#fff9cc">High-side</text>

              {/* High-side body diode */}
              <text x={x+34} y={74} fontSize="9" fill={col}>D{i*2+1}↕</text>

              {/* Low-side switch */}
              <rect x={x-30} y={185} width={60} height={38} rx={5} fill={col} opacity="0.75"/>
              <text x={x} y={201} textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff">Q{i*2+2}</text>
              <text x={x} y={215} textAnchor="middle" fontSize="9" fill="#fff9cc">Low-side</text>

              {/* Low-side body diode */}
              <text x={x+34} y={204} fontSize="9" fill={col}>D{i*2+2}↕</text>

              {/* Phase output node */}
              <circle cx={x} cy={162} r={7} fill={col}/>
              <line x1={x} y1={169} x2={x} y2={230} stroke={col} strokeWidth="2"/>

              {/* Phase label going to motor */}
              <text x={x} y={245} textAnchor="middle" fontSize="10" fontWeight="700" fill={col}>{ph}</text>
            </g>
          );
        })}

        {/* Motor coils schematic */}
        <rect x={680} y={100} width={180} height={120} rx={8} fill="#c49000" opacity="0.85"/>
        <text x={770} y={125} textAnchor="middle" fontSize="13" fontWeight="700" fill="#fff">3-Phase</text>
        <text x={770} y={143} textAnchor="middle" fontSize="13" fontWeight="700" fill="#fff">Motor</text>
        <text x={770} y={162} textAnchor="middle" fontSize="10" fill="#fff9cc">BLDC / PMSM</text>
        <text x={770} y={178} textAnchor="middle" fontSize="10" fill="#fff9cc">or Induction</text>
        <text x={770} y={196} textAnchor="middle" fontSize="10" fill="#fff9cc">Star or Delta wound</text>

        {/* Phase wires from inverter to motor */}
        {phases.map((_, i) => (
          <line key={i}
            x1={phaseX[i]} y1={162}
            x2={680} y2={130 + i*30}
            stroke={colors[i]} strokeWidth="2" strokeDasharray="6,3"
            markerEnd="url(#arrowTP)"/>
        ))}

        {/* DC source on the left */}
        <rect x={5} y={100} width={38} height={120} rx={4} fill="#7a4f00" opacity="0.8"/>
        <text x={24} y={155} textAnchor="middle" fontSize="9" fill="#fff" fontWeight="700" transform="rotate(-90,24,155)">V_dc SOURCE</text>
        <line x1={43} y1={112} x2={67} y2={112} stroke="#e07b00" strokeWidth="2"/>
        <line x1={43} y1={210} x2={67} y2={210} stroke="#555" strokeWidth="2"/>
      </svg>
      <div style={S.dCaption}>Six switching events per electrical cycle. PWM duty cycle of each leg controls the phase voltage applied to the motor winding.</div>
    </div>
  );
}

// ── Diagram: PWM Waveform & Duty Cycle ──────────────────────────────
function DiagramPWM() {
  const W = 900, H = 280;
  const startX = 70, endX = 860;
  const periodW = 160;
  const nPeriods = 4;
  const duties = [0.25, 0.5, 0.75, 0.5]; // duty cycles for each period shown

  const Y_carrier = 30,  H_carrier = 50;
  const Y_pwm25   = 110, H_pwm = 40;
  const Y_pwm50   = 165;
  const Y_pwm75   = 220;

  const buildPWM = (duty, yTop, h, nP) => {
    const pts = [];
    for (let i = 0; i < nP; i++) {
      const x0 = startX + i * periodW;
      const onW = duty * periodW;
      pts.push({ x1:x0, y1:yTop+h, x2:x0, y2:yTop });         // rise
      pts.push({ x1:x0, y1:yTop, x2:x0+onW, y2:yTop });        // high
      pts.push({ x1:x0+onW, y1:yTop, x2:x0+onW, y2:yTop+h }); // fall
      pts.push({ x1:x0+onW, y1:yTop+h, x2:x0+periodW, y2:yTop+h }); // low
    }
    return pts;
  };

  const drawLines = (pts, color) => pts.map((p, i) => (
    <line key={i} x1={p.x1} y1={p.y1} x2={p.x2} y2={p.y2} stroke={color} strokeWidth="2.5"/>
  ));

  // Carrier triangle wave
  const trianglePts = [];
  for (let i = 0; i < nPeriods * 2; i++) {
    const x = startX + i * periodW / 2;
    trianglePts.push(`${x},${Y_carrier + H_carrier}`);
    trianglePts.push(`${x + periodW/2},${Y_carrier}`);
  }
  trianglePts.push(`${startX + nPeriods*periodW},${Y_carrier + H_carrier}`);

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>PWM Generation — Carrier Triangle Wave vs Reference, Resulting Gate Signals</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        {/* Carrier wave */}
        <text x={6} y={Y_carrier + H_carrier/2 + 4} fontSize="9" fontWeight="700" fill="#7a4f00">Carrier</text>
        <polyline points={trianglePts.join(' ')} fill="none" stroke="#e8c84a" strokeWidth="1.8" strokeDasharray="4,2"/>
        {/* Reference lines */}
        <line x1={startX} y1={Y_carrier + H_carrier * 0.75} x2={endX} y2={Y_carrier + H_carrier * 0.75}
          stroke="#d4a000" strokeWidth="1.5" strokeDasharray="6,3"/>
        <line x1={startX} y1={Y_carrier + H_carrier * 0.5} x2={endX} y2={Y_carrier + H_carrier * 0.5}
          stroke="#b88000" strokeWidth="1.5" strokeDasharray="6,3"/>
        <line x1={startX} y1={Y_carrier + H_carrier * 0.25} x2={endX} y2={Y_carrier + H_carrier * 0.25}
          stroke="#e07b00" strokeWidth="1.5" strokeDasharray="6,3"/>
        <text x={endX+4} y={Y_carrier + H_carrier * 0.75 + 4} fontSize="9" fill="#d4a000">25%</text>
        <text x={endX+4} y={Y_carrier + H_carrier * 0.5 + 4} fontSize="9" fill="#b88000">50%</text>
        <text x={endX+4} y={Y_carrier + H_carrier * 0.25 + 4} fontSize="9" fill="#e07b00">75%</text>

        {/* PWM outputs */}
        <text x={6} y={Y_pwm25 + H_pwm/2 + 4} fontSize="9" fontWeight="700" fill="#d4a000">D=25%</text>
        {drawLines(buildPWM(0.25, Y_pwm25, H_pwm, nPeriods), '#d4a000')}

        <text x={6} y={Y_pwm50 + H_pwm/2 + 4} fontSize="9" fontWeight="700" fill="#b88000">D=50%</text>
        {drawLines(buildPWM(0.5,  Y_pwm50, H_pwm, nPeriods), '#b88000')}

        <text x={6} y={Y_pwm75 + H_pwm/2 + 4} fontSize="9" fontWeight="700" fill="#e07b00">D=75%</text>
        {drawLines(buildPWM(0.75, Y_pwm75, H_pwm, nPeriods), '#e07b00')}

        {/* Period brace */}
        <line x1={startX} y1={H-14} x2={startX+periodW} y2={H-14} stroke="#888" strokeWidth="1.2"/>
        <line x1={startX} y1={H-18} x2={startX} y2={H-10} stroke="#888" strokeWidth="1.2"/>
        <line x1={startX+periodW} y1={H-18} x2={startX+periodW} y2={H-10} stroke="#888" strokeWidth="1.2"/>
        <text x={startX+periodW/2} y={H-2} textAnchor="middle" fontSize="9" fill="#888">T_pwm = 1/f_pwm</text>

        {/* V_avg annotation */}
        <rect x={680} y={110} width={200} height={68} rx={4} fill="#fffbe6" stroke="#d4a000"/>
        <text x={780} y={126} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a4f00">Average voltage:</text>
        <text x={780} y={143} textAnchor="middle" fontSize="11" fill="#d4a000" fontFamily="'Courier New',monospace">V_avg = D × V_dc</text>
        <text x={780} y={160} textAnchor="middle" fontSize="9" fill="#888">D = duty cycle (0 to 1)</text>
        <text x={780} y={173} textAnchor="middle" fontSize="9" fill="#888">Motor inductance filters PWM → smooth I</text>

        {/* f_pwm note */}
        <rect x={680} y={186} width={200} height={52} rx={4} fill="#fffbe6" stroke="#b88000"/>
        <text x={780} y={202} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a4f00">Typical f_pwm:</text>
        <text x={780} y={218} textAnchor="middle" fontSize="9" fill="#333">DC motors: 10–50 kHz</text>
        <text x={780} y={231} textAnchor="middle" fontSize="9" fill="#333">BLDC / PMSM: 20–100 kHz</text>
      </svg>
      <div style={S.dCaption}>Motor inductance L acts as a low-pass filter: ΔI = V_dc × D × (1−D) / (L × f_pwm). Higher frequency → smoother current → less torque ripple.</div>
    </div>
  );
}

// ── Diagram: PID Control Loop ────────────────────────────────────────
function DiagramPID() {
  const W = 900, H = 260;

  const blocks = [
    { label:'Setpoint\nr(t)', x:20,  y:110, w:80,  h:50, color:'#c49000', isRound:false },
    { label:'Σ',             x:135, y:115, w:40,  h:40, color:'#d4a000', isRound:true  },
    { label:'PID\nController', x:215, y:105, w:110, h:60, color:'#d4a000', isRound:false },
    { label:'Power\nStage',  x:375, y:105, w:100, h:60, color:'#e07b00', isRound:false },
    { label:'Motor\n+ Load', x:525, y:105, w:100, h:60, color:'#b88000', isRound:false },
    { label:'Sensor',        x:525, y:210, w:100, h:40, color:'#b88000', isRound:false },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>PID Closed-Loop Control — Speed or Position Control</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="arrowPID" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#d4a000"/>
          </marker>
          <marker id="arrowPIDfb" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#b88000"/>
          </marker>
        </defs>

        {/* Blocks */}
        {blocks.map((b, i) => {
          const lines = b.label.split('\n');
          if (b.isRound) {
            return (
              <g key={i}>
                <circle cx={b.x+b.w/2} cy={b.y+b.h/2} r={b.w/2} fill={b.color} opacity="0.9"/>
                <text x={b.x+b.w/2} y={b.y+b.h/2+6} textAnchor="middle"
                  fontSize="18" fontWeight="700" fill="#fff">{b.label}</text>
              </g>
            );
          }
          return (
            <g key={i}>
              <rect x={b.x} y={b.y} width={b.w} height={b.h} rx={7} fill={b.color} opacity="0.9"/>
              {lines.map((l, li) => (
                <text key={li} x={b.x+b.w/2} y={b.y+b.h/2-6+li*18}
                  textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff">{l}</text>
              ))}
            </g>
          );
        })}

        {/* Forward arrows */}
        {/* setpoint → summing */}
        <line x1={100} y1={135} x2={135} y2={135} stroke="#d4a000" strokeWidth="2" markerEnd="url(#arrowPID)"/>
        {/* summing → PID */}
        <line x1={175} y1={135} x2={215} y2={135} stroke="#d4a000" strokeWidth="2" markerEnd="url(#arrowPID)"/>
        {/* PID → power stage */}
        <line x1={325} y1={135} x2={375} y2={135} stroke="#d4a000" strokeWidth="2" markerEnd="url(#arrowPID)"/>
        {/* power → motor */}
        <line x1={475} y1={135} x2={525} y2={135} stroke="#e07b00" strokeWidth="2" markerEnd="url(#arrowPID)"/>
        {/* motor → output */}
        <line x1={625} y1={135} x2={670} y2={135} stroke="#b88000" strokeWidth="2" markerEnd="url(#arrowPID)"/>
        <text x={680} y={130} fontSize="10" fill="#7a4f00" fontWeight="700">ω / θ</text>
        <text x={680} y={143} fontSize="9" fill="#888">output</text>

        {/* Sensor feedback path */}
        <line x1={575} y1={165} x2={575} y2={210} stroke="#b88000" strokeWidth="2"/>
        <line x1={625} y1={230} x2={155} y2={230} stroke="#b88000" strokeWidth="2" markerEnd="url(#arrowPIDfb)"/>
        <line x1={155} y1={230} x2={155} y2={155} stroke="#b88000" strokeWidth="2" markerEnd="url(#arrowPIDfb)"/>
        <text x={390} y={248} textAnchor="middle" fontSize="9" fill="#b88000" fontStyle="italic">y(t) — measured speed / position / current</text>

        {/* Error label */}
        <text x={193} y={108} textAnchor="middle" fontSize="9" fill="#7a4f00" fontWeight="700">e(t) = r−y</text>

        {/* Minus sign at summing junction */}
        <text x={147} y={148} textAnchor="middle" fontSize="12" fill="#e05000" fontWeight="700">−</text>
        <text x={147} y={126} textAnchor="middle" fontSize="12" fill="#d4a000" fontWeight="700">+</text>

        {/* PID internals annotation */}
        <rect x={215} y={170} width={110} height={60} rx={4} fill="#fffbe6" stroke="#d4a000"/>
        <text x={270} y={184} textAnchor="middle" fontSize="9" fontWeight="700" fill="#7a4f00">u(t) =</text>
        <text x={270} y={197} textAnchor="middle" fontSize="9" fill="#333">Kp·e</text>
        <text x={270} y={209} textAnchor="middle" fontSize="9" fill="#333">+ Ki·∫e dt</text>
        <text x={270} y={221} textAnchor="middle" fontSize="9" fill="#333">+ Kd·de/dt</text>

        {/* Labels inside PID block */}
        <text x={270} y={118} textAnchor="middle" fontSize="8" fill="#fff9cc">Kp  Ki  Kd</text>

        {/* Cascade annotation */}
        <rect x={700} y={80} width={190} height={90} rx={4} fill="#fffbe6" stroke="#b88000"/>
        <text x={795} y={97} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a4f00">Cascade Control</text>
        <text x={708} y={112} fontSize="8" fill="#333">Outer loop: position → speed ref</text>
        <text x={708} y={124} fontSize="8" fill="#333">Middle loop: speed → current ref</text>
        <text x={708} y={136} fontSize="8" fill="#333">Inner loop: current → duty cycle</text>
        <text x={708} y={148} fontSize="8" fill="#333">Inner must be 5–10× faster</text>
        <text x={708} y={160} fontSize="8" fill="#b88000">than outer loop bandwidth</text>
      </svg>
      <div style={S.dCaption}>Inner current loop (fastest) → speed loop → position loop (slowest). Each loop's output becomes the next loop's setpoint.</div>
    </div>
  );
}

// ── Diagram: Field-Oriented Control (FOC) Block Diagram ──────────────
function DiagramFOC() {
  const W = 900, H = 330;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Field-Oriented Control (FOC / Vector Control) — Complete Signal Chain</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="arrowFOC" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#d4a000"/>
          </marker>
          <marker id="arrowFOCfb" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#b88000"/>
          </marker>
        </defs>

        {/* ── Top row: forward path blocks ── */}
        {[
          { label:'Speed\nPI', x:20,  y:40,  w:80,  h:50, color:'#d4a000' },
          { label:'Id ref\nIq ref', x:120, y:40, w:70, h:50, color:'#c49000' },
          { label:'Id PI\nIq PI', x:210, y:40, w:80,  h:50, color:'#d4a000' },
          { label:'Inverse\nPark\n(dq→αβ)', x:310, y:33, w:90, h:64, color:'#b88000' },
          { label:'Space\nVector\nPWM', x:420, y:33, w:90, h:64, color:'#e07b00' },
          { label:'3-Phase\nInverter', x:530, y:40, w:90, h:50, color:'#c49000' },
          { label:'PMSM\nMotor', x:650, y:40, w:80, h:50, color:'#d4a000' },
        ].map((b, i) => {
          const lines = b.label.split('\n');
          return (
            <g key={i}>
              <rect x={b.x} y={b.y} width={b.w} height={b.h} rx={6} fill={b.color} opacity="0.9"/>
              {lines.map((l, li) => (
                <text key={li} x={b.x+b.w/2} y={b.y+18+li*14}
                  textAnchor="middle" fontSize="10" fontWeight="700" fill="#fff">{l}</text>
              ))}
            </g>
          );
        })}

        {/* Forward arrows top row */}
        {[[100,65],[190,65],[290,65],[400,65],[510,65],[620,65],[730,65]].map(([x,y],i,arr) => {
          if (i===arr.length-1) return null;
          return <line key={i} x1={x} y1={y} x2={arr[i+1][0]-80} y2={y}
            stroke="#d4a000" strokeWidth="2" markerEnd="url(#arrowFOC)"/>;
        })}
        {/* Manual arrows for gaps */}
        <line x1={100} y1={65} x2={120} y2={65} stroke="#d4a000" strokeWidth="2" markerEnd="url(#arrowFOC)"/>
        <line x1={190} y1={65} x2={210} y2={65} stroke="#d4a000" strokeWidth="2" markerEnd="url(#arrowFOC)"/>
        <line x1={290} y1={65} x2={310} y2={65} stroke="#d4a000" strokeWidth="2" markerEnd="url(#arrowFOC)"/>
        <line x1={400} y1={65} x2={420} y2={65} stroke="#d4a000" strokeWidth="2" markerEnd="url(#arrowFOC)"/>
        <line x1={510} y1={65} x2={530} y2={65} stroke="#d4a000" strokeWidth="2" markerEnd="url(#arrowFOC)"/>
        <line x1={620} y1={65} x2={650} y2={65} stroke="#d4a000" strokeWidth="2" markerEnd="url(#arrowFOC)"/>
        <line x1={730} y1={65} x2={760} y2={65} stroke="#d4a000" strokeWidth="2" markerEnd="url(#arrowFOC)"/>
        <text x={770} y={60} fontSize="10" fontWeight="700" fill="#7a4f00">τ / ω</text>

        {/* ── Bottom row: feedback transforms ── */}
        {[
          { label:'Clark\nTransform\n(abc→αβ)', x:530, y:165, w:90, h:64, color:'#b88000' },
          { label:'Park\nTransform\n(αβ→dq)', x:420, y:165, w:90, h:64, color:'#b88000' },
          { label:'Id, Iq\ncurrent\nfeedback', x:310, y:165, w:90, h:64, color:'#c49000' },
        ].map((b, i) => {
          const lines = b.label.split('\n');
          return (
            <g key={i}>
              <rect x={b.x} y={b.y} width={b.w} height={b.h} rx={6} fill={b.color} opacity="0.85"/>
              {lines.map((l, li) => (
                <text key={li} x={b.x+b.w/2} y={b.y+18+li*14}
                  textAnchor="middle" fontSize="9" fontWeight="700" fill="#fff">{l}</text>
              ))}
            </g>
          );
        })}

        {/* Phase current measurement */}
        <rect x={650} y={165} width={80} height={50} rx={6} fill="#b88000" opacity="0.7"/>
        <text x={690} y={183} textAnchor="middle" fontSize="9" fontWeight="700" fill="#fff">Current</text>
        <text x={690} y={196} textAnchor="middle" fontSize="9" fill="#fff9cc">Sensors</text>
        <text x={690} y={208} textAnchor="middle" fontSize="8" fill="#fff9cc">Ia, Ib, Ic</text>

        {/* Encoder / angle */}
        <rect x={740} y={165} width={90} height={50} rx={6} fill="#c49000" opacity="0.8"/>
        <text x={785} y={183} textAnchor="middle" fontSize="9" fontWeight="700" fill="#fff">Encoder /</text>
        <text x={785} y={196} textAnchor="middle" fontSize="9" fill="#fff9cc">Resolver</text>
        <text x={785} y={208} textAnchor="middle" fontSize="8" fill="#fff9cc">θ (rotor angle)</text>

        {/* Feedback path arrows */}
        <line x1={690} y1={165} x2={690} y2={115} stroke="#b88000" strokeWidth="1.8" markerEnd="url(#arrowFOCfb)"/>
        <line x1={690} y1={215} x2={620} y2={215} stroke="#b88000" strokeWidth="1.8" markerEnd="url(#arrowFOCfb)"/>
        <line x1={510} y1={197} x2={420+90} y2={197} stroke="#b88000" strokeWidth="1.8" markerEnd="url(#arrowFOCfb)"/>
        <line x1={420} y1={197} x2={310+90} y2={197} stroke="#b88000" strokeWidth="1.8" markerEnd="url(#arrowFOCfb)"/>
        <line x1={310} y1={197} x2={270} y2={197} stroke="#b88000" strokeWidth="1.8"/>
        <line x1={270} y1={197} x2={270} y2={90} stroke="#b88000" strokeWidth="1.8" markerEnd="url(#arrowFOCfb)"/>

        {/* θ angle feed to transforms */}
        <line x1={785} y1={165} x2={785} y2={140} stroke="#c49000" strokeWidth="1.5" strokeDasharray="4,2"/>
        <line x1={785} y1={140} x2={365} y2={140} stroke="#c49000" strokeWidth="1.5" strokeDasharray="4,2" markerEnd="url(#arrowFOC)"/>
        <text x={575} y={136} textAnchor="middle" fontSize="8" fill="#c49000">rotor angle θ → Park & Inverse Park transforms</text>

        {/* Setpoint */}
        <text x={5} y={55} fontSize="9" fontWeight="700" fill="#7a4f00">ω_ref</text>
        <line x1={20} y1={65} x2={20} y2={65} stroke="#d4a000" strokeWidth="1"/>

        {/* Key concept labels */}
        <rect x={10} y={250} width={880} height={68} rx={4} fill="#fffbe6" stroke="#d4a000"/>
        <text x={20} y={267} fontSize="10" fontWeight="700" fill="#7a4f00">Why FOC?</text>
        <text x={20} y={282} fontSize="9" fill="#333">FOC decouples torque (Iq) and flux (Id) control — just like a separately-excited DC motor. Id_ref is set to 0 (MTPA) or negative (flux weakening).</text>
        <text x={20} y={296} fontSize="9" fill="#333">Iq_ref commands torque directly. Because both PI loops operate on DC quantities (not sinusoidal), standard PI gains work perfectly with zero steady-state error.</text>
        <text x={20} y={310} fontSize="9" fill="#333">Clark transform: 3-phase (a,b,c) → 2-phase stationary (α,β). Park transform: stationary (α,β) → rotating (d,q) frame aligned to rotor flux axis.</text>
      </svg>
      <div style={S.dCaption}>FOC achieves DC-motor-like torque response from AC/BLDC motors. Current loop runs at 20–100 kHz; speed loop at 1–10 kHz.</div>
    </div>
  );
}

// ── Diagram: Motor Types Comparison ─────────────────────────────────
function DiagramMotorTypes() {
  const W = 900, H = 320;
  const labelW = 150;
  const colW = 178;
  const gap = 3;

  const motors = [
    { name:'Brushed DC',   color:'#c49000' },
    { name:'BLDC / PMSM',  color:'#d4a000' },
    { name:'AC Induction',  color:'#b88000' },
    { name:'Stepper',       color:'#e07b00' },
  ];

  const rows = [
    ['Controller type', ['Simple PWM H-Bridge','FOC / 6-step commutation','VFD (V/f or FOC)','Step pulse generator']],
    ['Feedback needed', ['Optional (open-loop ok)','Encoder / resolver','Often sensorless','None (open-loop)']],
    ['Efficiency',      ['60–80%','90–97%','85–92%','Low (all windings on)']],
    ['Torque control',  ['Easy (I ∝ torque)','Excellent with FOC','Good with FOC','Discrete steps']],
    ['Max speed',       ['Brush-limited ~10k RPM','Very high (50k+ RPM)','High, slip-limited','Low–medium RPM']],
    ['Cost / complexity',['Lowest','Medium–High','Low motor, high ctrl','Low']],
    ['Typical use',     ['RC, hobby, legacy','EV, servo, drones','HVAC, pumps, conveyors','CNC, 3D printers']],
  ];

  const rowH = 36, startY = 56;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Motor Types — Controller Requirements Comparison</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          {motors.map((m, i) => (
            <linearGradient key={i} id={`mcg${i}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={m.color}/>
              <stop offset="100%" stopColor={m.color} stopOpacity="0.78"/>
            </linearGradient>
          ))}
        </defs>

        {/* Label column */}
        <rect x={0} y={startY} width={labelW} height={rows.length*rowH} rx={4} fill="#fffbe6"/>

        {/* Column headers */}
        {motors.map((m, i) => {
          const colX = labelW + gap + i*(colW+gap);
          return (
            <g key={i}>
              <rect x={colX} y={8} width={colW} height={40} rx={6} fill={`url(#mcg${i})`}/>
              <text x={colX+colW/2} y={33} textAnchor="middle" fontSize="12" fontWeight="700"
                fill="#fff" fontFamily="'Georgia',serif">{m.name}</text>
            </g>
          );
        })}

        {/* Row labels */}
        {rows.map(([label], ri) => (
          <g key={ri}>
            <rect x={0} y={startY+ri*rowH} width={labelW} height={rowH-2} rx={3}
              fill={ri%2===0?'#fffbe6':'#fff4cc'}/>
            <text x={8} y={startY+ri*rowH+rowH/2+5} fontSize="10" fontWeight="700"
              fill="#7a4f00">{label}</text>
          </g>
        ))}

        {/* Data cells */}
        {motors.map((m, mi) => {
          const colX = labelW+gap+mi*(colW+gap);
          return rows.map(([, vals], ri) => (
            <g key={`${mi}-${ri}`}>
              <rect x={colX} y={startY+ri*rowH} width={colW} height={rowH-2} rx={3}
                fill={ri%2===0?'#fffcf0':'#fffde8'} stroke="#e8c84a" strokeWidth="0.5"/>
              <text x={colX+colW/2} y={startY+ri*rowH+rowH/2+5} textAnchor="middle"
                fontSize="9" fill="#1a1200" fontFamily="'Courier New',monospace">{vals[mi]}</text>
            </g>
          ));
        })}

        <line x1={0} y1={startY+rows.length*rowH} x2={W} y2={startY+rows.length*rowH} stroke="#d4a000" strokeWidth="1.5"/>
      </svg>
      <div style={S.dCaption}>BLDC/PMSM motors dominate modern high-performance applications due to efficiency and torque density — at the cost of controller complexity</div>
    </div>
  );
}

// ── Diagram: Torque-Speed Curve ──────────────────────────────────────
function DiagramTorqueSpeed() {
  const W = 900, H = 290;
  const originX = 80, originY = 220;
  const graphW = 440, graphH = 180;

  // DC motor torque-speed line: T = T_stall × (1 - ω/ω_noload)
  const tStall = graphH * 0.9;
  const wNoLoad = graphW * 0.9;
  const nPoints = 50;

  const motorLine = Array.from({length: nPoints}, (_, i) => {
    const frac = i / (nPoints-1);
    return {
      x: originX + frac * wNoLoad,
      y: originY - tStall * (1 - frac),
    };
  });

  // Power curve: P = T × ω ∝ frac × (1-frac)
  const powerLine = Array.from({length: nPoints}, (_, i) => {
    const frac = i / (nPoints-1);
    const p = frac * (1-frac) * 4; // scale to fit
    return {
      x: originX + frac * wNoLoad,
      y: originY - p * graphH * 0.5,
    };
  });

  const toPath = pts => 'M ' + pts.map(p=>`${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(' L ');

  // Operating regions
  const contX = originX + wNoLoad * 0.55;
  const baseX = originX + wNoLoad * 0.45;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>DC / BLDC Motor Torque–Speed Curve, Operating Regions & Power</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="arrowTS" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#7a4f00"/>
          </marker>
        </defs>

        {/* Axes */}
        <line x1={originX} y1={originY} x2={originX+graphW} y2={originY}
          stroke="#7a4f00" strokeWidth="2" markerEnd="url(#arrowTS)"/>
        <line x1={originX} y1={originY} x2={originX} y2={originY-graphH}
          stroke="#7a4f00" strokeWidth="2" markerEnd="url(#arrowTS)"/>
        <text x={originX+graphW+8} y={originY+5} fontSize="11" fill="#7a4f00" fontWeight="700">ω (speed)</text>
        <text x={originX-10} y={originY-graphH-8} fontSize="11" fill="#7a4f00" fontWeight="700" textAnchor="end">τ</text>
        <text x={originX-12} y={originY-graphH+4} fontSize="9" fill="#888">(torque)</text>

        {/* Continuous operating region shading */}
        <rect x={originX} y={originY-tStall} width={contX-originX} height={tStall} fill="#d4a000" opacity="0.08"/>
        <text x={(originX+contX)/2} y={originY-graphH*0.35} textAnchor="middle"
          fontSize="10" fill="#d4a000" fontWeight="700">Continuous</text>
        <text x={(originX+contX)/2} y={originY-graphH*0.22} textAnchor="middle"
          fontSize="9" fill="#d4a000">operating</text>
        <text x={(originX+contX)/2} y={originY-graphH*0.12} textAnchor="middle"
          fontSize="9" fill="#d4a000">region</text>

        {/* Flux weakening region */}
        <rect x={baseX} y={originY-graphH*0.7} width={wNoLoad-baseX+originX} height={graphH*0.7}
          fill="#e07b00" opacity="0.07"/>
        <text x={baseX+(wNoLoad-baseX)/2+originX/2} y={originY-graphH*0.55} textAnchor="middle"
          fontSize="9" fill="#e07b00" fontWeight="700">Flux Weakening</text>
        <text x={baseX+(wNoLoad-baseX)/2+originX/2} y={originY-graphH*0.44} textAnchor="middle"
          fontSize="9" fill="#e07b00">(constant power)</text>

        {/* Base speed line */}
        <line x1={baseX} y1={originY} x2={baseX} y2={originY-graphH*0.75}
          stroke="#b88000" strokeWidth="1.5" strokeDasharray="5,3"/>
        <text x={baseX} y={originY+14} textAnchor="middle" fontSize="9" fill="#b88000">ω_base</text>

        {/* Motor torque-speed line */}
        <path d={toPath(motorLine)} fill="none" stroke="#d4a000" strokeWidth="3"/>

        {/* Power curve */}
        <path d={toPath(powerLine)} fill="none" stroke="#e07b00" strokeWidth="2" strokeDasharray="6,3"/>

        {/* Key points */}
        <circle cx={originX} cy={originY-tStall} r={5} fill="#d4a000"/>
        <text x={originX-4} y={originY-tStall-8} textAnchor="end" fontSize="9" fill="#d4a000">T_stall</text>
        <circle cx={originX+wNoLoad} cy={originY} r={5} fill="#d4a000"/>
        <text x={originX+wNoLoad} y={originY+14} textAnchor="middle" fontSize="9" fill="#d4a000">ω_no-load</text>

        {/* Max power point */}
        <circle cx={originX+wNoLoad/2} cy={originY-tStall*0.25*4*0.5} r={5} fill="#e07b00"/>
        <text x={originX+wNoLoad/2+8} y={originY-tStall*0.25*4*0.5-6} fontSize="9" fill="#e07b00">P_max = T_stall×ω_nl/4</text>

        {/* Legend */}
        <rect x={560} y={30} width={320} height={230} rx={6} fill="#fffbe6" stroke="#d4a000"/>
        <text x={720} y={50} textAnchor="middle" fontSize="12" fontWeight="700" fill="#7a4f00">Operating Regions</text>

        {[
          { label:'T_stall', desc:'Max torque at ω=0\n= V / R_winding', color:'#d4a000' },
          { label:'ω_no-load', desc:'Max speed at T=0\n= V / (K_e × Φ)', color:'#d4a000' },
          { label:'P_max', desc:'At 50% speed & 50% torque\nP = T×ω = T_s×ω_nl/4', color:'#e07b00' },
          { label:'Continuous region', desc:'Thermally safe indefinitely\nlimited by I²R heating', color:'#d4a000' },
          { label:'Flux weakening', desc:'Reduce field to exceed ω_base\nP = const, T decreases', color:'#e07b00' },
          { label:'K_t (torque const)', desc:'τ = K_t × I  (Nm/A)\nK_t = K_e (SI units)', color:'#b88000' },
          { label:'Back-EMF', desc:'V_bemf = K_e × ω\nReduces current at speed', color:'#b88000' },
        ].map((item, i) => {
          const lines = item.desc.split('\n');
          return (
            <g key={i}>
              <text x={570} y={68+i*27} fontSize="9" fontWeight="700" fill={item.color}>{item.label}:</text>
              {lines.map((l, li) => (
                <text key={li} x={570} y={68+i*27+10+li*11} fontSize="8" fill="#333">{l}</text>
              ))}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Torque and speed are inversely related in constant-voltage operation. Controller must limit current to stay within the continuous operating region.</div>
    </div>
  );
}

// ── Diagram: Gate Driver & Shoot-Through Protection ──────────────────
function DiagramGateDriver() {
  const W = 900, H = 280;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Gate Driver Circuit — Bootstrap, Isolation, and Dead-Time Generation</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="arrowGD" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#d4a000"/>
          </marker>
        </defs>

        {/* MCU / PWM source */}
        <rect x={10} y={100} width={110} height={90} rx={7} fill="#c49000" opacity="0.9"/>
        <text x={65} y={120} textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff">MCU</text>
        <text x={65} y={136} textAnchor="middle" fontSize="9" fill="#fff9cc">PWM_H</text>
        <text x={65} y={150} textAnchor="middle" fontSize="9" fill="#fff9cc">PWM_L</text>
        <text x={65} y={166} textAnchor="middle" fontSize="9" fill="#fff9cc">3.3V / 5V logic</text>
        <text x={65} y={180} textAnchor="middle" fontSize="9" fill="#fff9cc">dead-time inserted</text>

        {/* Gate driver IC */}
        <rect x={160} y={80} width={130} height={130} rx={7} fill="#d4a000" opacity="0.9"/>
        <text x={225} y={104} textAnchor="middle" fontSize="12" fontWeight="700" fill="#fff">Gate Driver</text>
        <text x={225} y={120} textAnchor="middle" fontSize="9" fill="#fff9cc">e.g. IR2110</text>
        <text x={225} y={134} textAnchor="middle" fontSize="9" fill="#fff9cc">UCC27211</text>
        <text x={225} y={152} textAnchor="middle" fontSize="9" fill="#fff9cc">Bootstrap cap</text>
        <text x={225} y={165} textAnchor="middle" fontSize="9" fill="#fff9cc">C_boot ≈ 100nF</text>
        <text x={225} y={182} textAnchor="middle" fontSize="9" fill="#fff9cc">drives gate at</text>
        <text x={225} y={195} textAnchor="middle" fontSize="9" fill="#fff9cc">10–20V peak</text>

        {/* Arrows MCU → Gate driver */}
        <line x1={120} y1={135} x2={160} y2={135} stroke="#d4a000" strokeWidth="2" markerEnd="url(#arrowGD)"/>
        <line x1={120} y1={155} x2={160} y2={155} stroke="#d4a000" strokeWidth="2" markerEnd="url(#arrowGD)"/>

        {/* High-side MOSFET */}
        <rect x={340} y={30} width={110} height={80} rx={6} fill="#e07b00" opacity="0.9"/>
        <text x={395} y={56} textAnchor="middle" fontSize="12" fontWeight="700" fill="#fff">Q_high</text>
        <text x={395} y={72} textAnchor="middle" fontSize="9" fill="#fff9cc">High-side MOSFET</text>
        <text x={395} y={86} textAnchor="middle" fontSize="9" fill="#fff9cc">Source floating!</text>
        <text x={395} y={100} textAnchor="middle" fontSize="9" fill="#fff9cc">(switches with load)</text>

        {/* Low-side MOSFET */}
        <rect x={340} y={175} width={110} height={80} rx={6} fill="#b88000" opacity="0.9"/>
        <text x={395} y={201} textAnchor="middle" fontSize="12" fontWeight="700" fill="#fff">Q_low</text>
        <text x={395} y={217} textAnchor="middle" fontSize="9" fill="#fff9cc">Low-side MOSFET</text>
        <text x={395} y={233} textAnchor="middle" fontSize="9" fill="#fff9cc">Source = GND</text>
        <text x={395} y={247} textAnchor="middle" fontSize="9" fill="#fff9cc">(easier to drive)</text>

        {/* Gate drive arrows */}
        <line x1={290} y1={110} x2={340} y2={70} stroke="#e07b00" strokeWidth="2" markerEnd="url(#arrowGD)"/>
        <line x1={290} y1={160} x2={340} y2={215} stroke="#b88000" strokeWidth="2" markerEnd="url(#arrowGD)"/>

        {/* V_supply and GND */}
        <line x1={395} y1={10} x2={395} y2={30} stroke="#e07b00" strokeWidth="3"/>
        <text x={395} y={8} textAnchor="middle" fontSize="10" fontWeight="700" fill="#e07b00">V_dc</text>
        <line x1={395} y1={255} x2={395} y2={270} stroke="#555" strokeWidth="3"/>
        <text x={395} y={278} textAnchor="middle" fontSize="10" fontWeight="700" fill="#555">GND</text>

        {/* Phase output */}
        <circle cx={395} cy={145} r={6} fill="#d4a000"/>
        <line x1={401} y1={145} x2={460} y2={145} stroke="#d4a000" strokeWidth="3" markerEnd="url(#arrowGD)"/>
        <text x={468} y={140} fontSize="10" fontWeight="700" fill="#7a4f00">Phase</text>
        <text x={468} y={153} fontSize="9" fill="#888">output</text>

        {/* Right panel — annotations */}
        <rect x={510} y={20} width={376} height={240} rx={6} fill="#fffbe6" stroke="#d4a000"/>
        <text x={698} y={40} textAnchor="middle" fontSize="12" fontWeight="700" fill="#7a4f00">Gate Driver Key Concepts</text>

        {[
          { title:'Bootstrap circuit', body:'Charges C_boot when Q_low is ON via D_boot\nC_boot provides floating supply to drive high-side gate\nLimitation: cannot hold Q_high ON indefinitely (charge depletes)', color:'#d4a000' },
          { title:'Gate resistor R_g', body:'R_g_on (2–22Ω): limits dI/dt, reduces switching noise\nR_g_off (0–10Ω): faster turn-off without oscillation\nTrade-off: smaller R_g → faster switching → more EMI', color:'#b88000' },
          { title:'Dead-time', body:'Both switches OFF for t_dead (50ns–2µs) between transitions\nPrevents shoot-through; body diode conducts instead\nToo long → distorted output; too short → shoot-through risk', color:'#e07b00' },
          { title:'Isolation options', body:'Transformer-isolated (pulse transformer): simple, galvanic\nOptocoupler (HCPL-314J): moderate speed, reliable\nDigital isolator (Si8261): fast, accurate, preferred modern choice', color:'#c49000' },
        ].map((item, i) => {
          const bodyLines = item.body.split('\n');
          const y0 = 55 + i * 55;
          return (
            <g key={i}>
              <text x={520} y={y0} fontSize="10" fontWeight="700" fill={item.color}>{item.title}:</text>
              {bodyLines.map((l, li) => (
                <text key={li} x={520} y={y0+12+li*12} fontSize="8" fill="#333">{l}</text>
              ))}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Gate driver sits between the low-voltage MCU and the high-voltage power switches — providing voltage translation, isolation, and protection.</div>
    </div>
  );
}

// ── Main Export ──────────────────────────────────────────────────────
export default function MotorController() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Motor Controllers in Electrical Engineering — Complete Reference</h1>
      <p style={S.p}>
        A motor controller is the electronic system that governs how electrical energy is delivered to a motor —
        controlling its speed, torque, direction, and position. It bridges the gap between a low-power digital
        command (a number from a microcontroller) and the high-power switching required to actually move a load.
        Every modern motor controller combines power electronics, signal processing, and control theory into a
        tightly coupled real-time system.
      </p>

      <InfoBox title="Motor Controller at a Glance" items={[
        "Core function: Convert a DC supply into controlled voltage/current waveforms that drive a motor",
        "Power stage: Switches (MOSFETs or IGBTs) arranged in H-bridge (DC) or 3-phase inverter (AC/BLDC) topologies",
        "Modulation: PWM duty cycle sets average voltage; frequency sets ripple current and audible noise",
        "Control: PID loops for speed/position; FOC (vector control) for high-performance torque control",
        "Feedback: Current sensors (shunt/Hall), position sensors (encoder/resolver/Hall), temperature sensors",
        "Protection: Over-current, over-voltage, under-voltage, over-temperature, shoot-through prevention",
        "Standards: IEC 61800 (adjustable speed drives), UL 508C (power conversion), ISO 26262 (automotive ASIL)",
        "Key ICs: Gate drivers (IR2110, UCC27211), current sense amps (INA240), motor driver SoCs (DRV8305, TMC4671)",
      ]}/>

      <h2 style={S.h2}>System Architecture</h2>
      <p style={S.p}>
        Every motor controller, from a tiny hobby ESC to a 500 kW industrial drive, shares the same
        fundamental architecture. A command source sets the desired operating point. A digital controller
        computes the required switching pattern. A gate driver translates low-voltage logic to high-voltage
        gate signals. The power stage converts DC bus energy into motor phase currents. Sensors close the loop.
      </p>
      <DiagramSystemArch/>

      <Table2 rows={[
        ["Command sources","PWM input (RC hobby), CAN/CANopen (automotive/industrial), UART/RS-485, SPI/I²C registers\nAnalog reference (0–5V or ±10V), step/direction pulses (stepper), EtherCAT / CANopen DS402"],
        ["Microcontroller role","Runs PID/FOC algorithm, generates PWM, reads ADC, handles faults, communicates\nTypical: STM32 (TIM1 advanced timer), TMS320F280xx (C2000 DSP), RP2040 with PIO"],
        ["DSP / dedicated silicon","TI C2000 F28379D: dual-core, 200MHz, 16-ch ADC, CLA co-processor for control loops\nInfineon XMC4000, NXP S32K, Microchip dsPIC33 — all optimised for motor control"],
        ["Power semiconductors","MOSFETs: low voltage (<200V), fast switching, RDS_on matters — Si or GaN\nIGBTs: high voltage (>400V), slower, V_CE_sat matters — used in industrial VFDs, EV traction\nSiC MOSFETs: best of both — high V, fast switching — used in EV chargers, solar inverters"],
        ["Current sensing","Low-side shunt: simple, ground-referenced, but signal lost during high-side switch ON time\nHigh-side shunt: measures actual phase current; needs differential amplifier\nHall-effect sensor: isolated, wide range, lower accuracy; in-line with motor lead"],
        ["Thermal management","Power loss P = I²×R_ds_on (conduction) + f×Q_g×V_gs (switching)\nHeat sink, thermal interface material, active cooling (fan/liquid) for >500W\nPTC thermistor or NTC on MOSFET case; derate current above T_junction limit"],
      ]}/>

      <h2 style={S.h2}>H-Bridge — DC Motor Control</h2>
      <p style={S.p}>
        The H-bridge is the fundamental building block for bidirectional DC motor control. Four switches
        arranged in an H shape allow current to flow through the motor in either direction. Pulse-Width
        Modulation of the switches controls the average voltage, and thus the speed. The H-bridge is also
        used as one leg of a 3-phase inverter.
      </p>
      <DiagramHBridge/>
      <Table2 rows={[
        ["Switch technology","Small motors (<5A): integrated driver ICs (DRV8833, TB6612, L298N)\nMedium motors (5–50A): discrete MOSFETs + gate driver IC\nHigh power (>50A): paralleled MOSFETs or IGBTs on custom PCB or power module"],
        ["Sign-magnitude PWM","One direction switch held ON; other PWM'd. Motor coasts during OFF time.\nSimpler; switch transitions only on one pair per direction change"],
        ["Lock-antiphase PWM","Both legs PWM'd complementarily; motor always driven (no coast)\nBetter linearity, faster response; higher switching losses"],
        ["Synchronous rectification","Both low-side switches conduct during freewheeling (instead of body diode)\nReduces conduction loss: V_diode≈0.7V replaced by I×R_ds_on<<0.7V at low current"],
        ["Regenerative braking","Reverse the active H-bridge switches → motor becomes generator → energy fed back\nPassive braking: short motor terminals (both low-sides ON) → kinetic energy → heat"],
        ["Body diode","Every MOSFET has an intrinsic body diode; conducts during dead-time\nSlow diodes cause reverse recovery loss; select low Q_rr MOSFETs for high-frequency operation"],
        ["MOSFET selection","R_ds_on(max) at T_j: conduction loss = I²×R_ds_on\nQ_g (total gate charge): switching loss ∝ Q_g × f × V_gs\nV_ds rating: ≥ 2× supply voltage for transient protection margin"],
      ]}/>

      <h2 style={S.h2}>Three-Phase Inverter — BLDC & AC Motor Control</h2>
      <p style={S.p}>
        A three-phase voltage source inverter uses six switches (three half-bridges) to synthesise three
        sinusoidal phase voltages from a DC bus. This topology drives Brushless DC (BLDC), Permanent Magnet
        Synchronous (PMSM), and AC Induction motors. It is found in everything from drone ESCs to electric
        vehicle traction inverters.
      </p>
      <DiagramThreePhase/>
      <Table2 rows={[
        ["6-step (trapezoidal) commutation","Only 2 of 3 phases active at a time; switches commutated every 60° electrical\nSimple to implement; requires Hall sensors for 60° position information\nTorque ripple at commutation points; lower efficiency than FOC"],
        ["Sinusoidal PWM (SPWM)","Sinusoidal reference compared against triangle carrier → per-phase duty cycles\nLower harmonic distortion than 6-step; max linear modulation index = 0.866\nRequires continuous position feedback (encoder or sensorless estimator)"],
        ["Space Vector PWM (SVPWM)","Treats 3-phase output as a 2D space vector; selects optimal switch states\nHigher DC bus utilisation: M_max = 1.0 vs 0.866 for SPWM (15% more voltage)\nLower THD; standard in FOC implementations; computationally efficient"],
        ["Over-modulation","M > 1: PWM enters non-linear region; output approaches 6-step square wave\nAllows up to 27% more fundamental voltage; used in high-speed/flux-weakening\nIncreases harmonic content; must be handled carefully in FOC"],
        ["Neutral point voltage","Star (Y) connected motor: neutral floats; line-to-line voltage = √3 × phase voltage\nDelta (Δ) connected: circulating currents possible; no neutral available"],
        ["DC bus capacitor","Large electrolytic (100–2200µF) absorbs switching ripple current\nRipple current rating critical: I_ripple ≈ I_out × √(D×(1-D))\nFilm capacitors in parallel for low ESR at high frequency"],
        ["Sensorless control","Back-EMF zero-crossing detection (6-step): works above ~10% speed\nFlux observer / MRAS (model reference adaptive system): works at low speed\nHigh-frequency injection (FOC): works at standstill — used in EV, servo"],
      ]}/>

      <h2 style={S.h2}>PWM — Pulse Width Modulation</h2>
      <p style={S.p}>
        PWM is the universal method for controlling average power delivery to a motor using on/off switching.
        The ratio of ON time to total period (duty cycle D) linearly sets the average voltage. Motor inductance
        naturally integrates the switching waveform into a nearly smooth current.
      </p>
      <DiagramPWM/>
      <Table2 rows={[
        ["Duty cycle D","D = t_on / T_pwm.  V_avg = D × V_dc.  Speed ∝ V_avg (for DC motors)\nD=0: motor off. D=0.5: half voltage. D=1.0: full voltage."],
        ["PWM frequency f_pwm","Higher f: less current ripple, less torque ripple, less audible noise, more switching loss\nLower f: less switching loss, more ripple, may cause audible whine (20Hz–20kHz)\nDC motors: 10–50 kHz; BLDC/PMSM: 20–100 kHz; WBG (GaN/SiC): 200kHz+"],
        ["Current ripple ΔI","ΔI = V_dc × D × (1-D) / (L × f_pwm)\nLargest at D=0.5; reduced by higher f or larger L (motor inductance or added inductor)"],
        ["Centre-aligned (symmetric) PWM","Triangle carrier; switching occurs at both edges of period\nReduces current ripple by factor 2× vs edge-aligned; preferred in motor control\nAllows simultaneous ADC sampling at PWM midpoint (no switching noise)"],
        ["Edge-aligned (asymmetric) PWM","Sawtooth carrier; simpler hardware; single-edge switching per period\nUsed in simple applications; more current ripple; ADC sampling timing more complex"],
        ["ADC synchronisation","Sample phase currents at PWM midpoint (centre of ON time) → minimum ripple error\nTrigger ADC from PWM counter underflow/overflow event in hardware\nCritical: current samples must be valid before FOC computation completes in same cycle"],
        ["Complementary PWM","High-side and low-side signals are complementary with dead-time inserted in hardware\nMCU timer (TIM1 on STM32) generates complementary outputs with programmable dead-time\nDead-time distortion: average output voltage error ≈ ±t_dead × V_dc × f_pwm"],
        ["Soft switching","ZVS (Zero Voltage Switching): switch turns on when drain-source voltage = 0\nZCS (Zero Current Switching): switch turns off when current = 0\nReduces switching losses; used in resonant converters and advanced SiC/GaN designs"],
      ]}/>

      <h2 style={S.h2}>PID Control</h2>
      <p style={S.p}>
        The Proportional-Integral-Derivative (PID) controller is the workhorse of motor control. Three
        cascaded PID loops — current (innermost), speed (middle), and position (outermost) — each operating
        at a different bandwidth, provide precise, robust control from standstill to full speed.
      </p>
      <DiagramPID/>
      <Table2 rows={[
        ["Proportional (Kp)","Output ∝ instantaneous error. Reduces error but cannot eliminate it alone.\nToo high Kp → oscillation; too low → sluggish response\nFor current loop: Kp = L × ω_c  where ω_c = desired crossover frequency"],
        ["Integral (Ki)","Accumulates error over time; eliminates steady-state error.\nCauses integrator windup when output saturates (motor at max current/voltage)\nAnti-windup: clamp integrator output, or back-calculate from saturation"],
        ["Derivative (Kd)","Responds to rate of change of error; damps overshoot.\nHighly sensitive to noise — always filter derivative: D_filtered = Kd × s / (τ_f·s+1)\nOften omitted in current loops; useful in position loops"],
        ["Current loop tuning","Bandwidth: ω_c = R/(2L) to ω_c = R/L (depending on crossover margin needed)\nKp = L × ω_c;  Ki = R × ω_c  (pole-zero cancellation method)\nMust run much faster than mechanical loops: typically 20–100 kHz"],
        ["Speed loop tuning","Bandwidth: 5–50 Hz typical (limited by mechanical resonance)\nKp = J × ω_c;  Ki = B × ω_c  (J=inertia, B=friction, ω_c=crossover)\nOuter loop bandwidth ≤ 1/5 of inner current loop bandwidth"],
        ["Position loop tuning","Bandwidth: 1–10 Hz (limited by speed loop below it)\nOften P-only (no I/D needed if speed loop handles dynamics)\nFeed-forward velocity term greatly improves trajectory following"],
        ["Anti-windup","Back-calculation: subtract saturated amount from integrator at each step\nConditional integration: freeze integrator when output saturates\nClamping: hard-limit integrator state to ±max_integral value"],
        ["Discrete implementation","Tustin (bilinear) transform: best frequency-domain accuracy for PI\nForward Euler: simple; can be unstable at large T_s\nSample rate: minimum 10× loop bandwidth; 20–100× preferred for motor control"],
      ]}/>

      <h2 style={S.h2}>Field-Oriented Control (FOC)</h2>
      <p style={S.p}>
        Field-Oriented Control — also called vector control — is the state-of-the-art algorithm for
        high-performance AC and BLDC motor control. By mathematically transforming the motor's reference frame
        to one that rotates with the rotor flux, FOC allows independent, linear control of torque and flux
        using simple DC-quantity PI controllers — just like a DC motor.
      </p>
      <DiagramFOC/>
      <Table2 rows={[
        ["Clarke transform","Converts 3-phase (a,b,c) currents to orthogonal 2-phase stationary frame (α,β)\nI_α = I_a;  I_β = (I_a + 2I_b) / √3\nReduces 3 variables to 2; frame is stationary (fixed to stator)"],
        ["Park transform","Rotates stationary (α,β) frame to rotating (d,q) frame aligned with rotor flux\nI_d = I_α cos(θ) + I_β sin(θ);  I_q = -I_α sin(θ) + I_β cos(θ)\nIn d-q frame: Id and Iq are DC quantities → PI controllers work perfectly"],
        ["d-axis (flux component)","Id controls rotor flux linkage. In PMSM: set Id=0 for maximum torque per ampere (MTPA)\nNegative Id used for flux weakening (field weakening) above base speed\nIn induction motor: Id_ref = λ_r_ref / L_m (sets rotor flux level)"],
        ["q-axis (torque component)","Iq directly commands torque: τ = (3/2) × p × λ_r × Iq  (p=pole pairs)\nFOC's key advantage: Iq can be stepped instantly → DC-motor-like torque response\nResponse time limited only by current loop bandwidth (microseconds)"],
        ["Rotor angle θ estimation","Encoder: most accurate; 1024–65536 CPR optical or magnetic\nResolver: robust, high-temp, used in automotive and aerospace\nSensorless (MRAS/EMF observer): eliminates sensor; works >~5% speed\nHigh-frequency injection: works at zero speed; injects carrier on d-axis, extracts angle from Iq response"],
        ["Maximum Torque Per Ampere","MTPA: optimal Id to produce required torque with minimum current (minimum loss)\nFor SPM motor: Id=0. For IPM: Id<0 (exploits reluctance torque)\nLook-up table or real-time optimisation algorithm; critical for EV efficiency"],
        ["Flux weakening","Above ω_base: V_limit reached. Reduce Id (more negative) → reduce flux → allow higher speed\nConstant power region: τ ∝ 1/ω while P = τω = constant\nVoltage limit: √(Vd²+Vq²) ≤ V_dc/√3; current limit: √(Id²+Iq²) ≤ I_max"],
        ["Execution timing","Current sampling → Clarke → Park → PI(d) → PI(q) → Inverse Park → SVPWM → gate signals\nMust complete within one PWM period (10–50 µs at 20–100 kHz)\nFixed-point DSP or hardware accelerators (TI CLA, Cortex-M4 FPU) make this feasible"],
      ]}/>

      <h2 style={S.h2}>Motor Types & Controller Requirements</h2>
      <DiagramMotorTypes/>

      <h2 style={S.h2}>Torque–Speed Characteristics</h2>
      <DiagramTorqueSpeed/>
      <Table2 rows={[
        ["Back-EMF constant K_e","V_bemf = K_e × ω  (V·s/rad or V/RPM)\nHigher K_e: more torque per amp but lower max speed at given V\nK_e = K_t in SI units (both in V·s/rad = Nm/A)"],
        ["Torque constant K_t","τ = K_t × I  (Nm/A). Fundamental relationship for all DC/BLDC motors.\nK_t = 60 / (2π × K_v)  where K_v is in RPM/V (kV rating of BLDC motors)"],
        ["Motor resistance R_a","At stall: I_stall = V / R_a. Defines maximum current at zero speed.\nDetermines copper loss: P_copper = I² × R_a\nArmature resistance increases with temperature: R(T) = R_20 × (1 + α × ΔT)"],
        ["Motor inductance L_a","Filters current ripple; determines current loop bandwidth: ω_c ≤ R/L\nHigher inductance → lower ripple at same PWM frequency\nSurface PM motors: low inductance. Interior PM: higher, direction-dependent (Ld ≠ Lq)"],
        ["Viscous friction B","τ_friction = B × ω. Represents bearing, air, and brush friction.\nDetermined from free-running deceleration test: B = J × Δω/Δt\nSpeed loop integral term cancels steady-state error due to friction"],
        ["Load inertia J","τ_net = J × α  (Newton's 2nd law for rotation; α = angular acceleration)\nTotal J = J_motor + J_load/gear_ratio²\nHigher J → slower speed response; requires detuned speed loop or higher gains"],
        ["Motor electrical time const","τ_e = L_a / R_a. Time for current to reach 63% of final value.\nCurrent loop crossover must be << 1/τ_e for stable control"],
        ["Motor mechanical time const","τ_m = J × R_a / K_t². Time for speed to reach 63% of final value.\nτ_m >> τ_e always; speed loop must be slower than current loop"],
      ]}/>

      <h2 style={S.h2}>Gate Drivers & Power Stage Design</h2>
      <DiagramGateDriver/>
      <Table2 rows={[
        ["Gate driver requirements","Source/sink current: peak I_gate = V_gs / R_g. Drive ≥1A for fast switching.\nInput threshold compatible with MCU: 3.3V or 5V logic\nPropagation delay: <100ns and matched between high/low side"],
        ["Bootstrap operation","C_boot charged to ~V_gs_th via D_boot when Q_low=ON and phase node=GND\nHigh-side switch gate driven by C_boot voltage floating on phase node\nMinimum Q_low ON time needed to recharge C_boot: t_min = C_boot × V_supply / I_charge"],
        ["Isolated gate drivers","Required when MOSFET source is not near logic ground (all high-side switches)\nDigital isolators (Si8261, ISO7221): 5 kV isolation, <10ns propagation delay\nTransformer drive: works for high-frequency applications, limited duty cycle range"],
        ["Switching losses","E_sw_on  = 0.5 × V_ds × I_d × t_rise + Q_rr × V_ds\nE_sw_off = 0.5 × V_ds × I_d × t_fall\nTotal P_sw = (E_sw_on + E_sw_off) × f_pwm — linear with frequency"],
        ["Snubber circuits","RC snubber across switch: damps voltage overshoot from parasitic inductance\nV_spike = L_parasitic × dI/dt — minimise with low-inductance PCB layout\nTVS diodes for clamping; gate resistor R_g also reduces dV/dt"],
        ["PCB layout rules","Minimise high-current loop area (DC bus capacitor → high-side → phase → low-side → cap)\nSeparate high-current power plane from gate drive / signal traces\nGate traces: keep short (<5cm), no vias in gate path; match top/bottom pairs"],
        ["Thermal resistance","R_θJC (junction-to-case): given by datasheet. R_θCS: thermal paste/pad.\nR_θSA (heatsink-to-ambient): determined by heatsink size and airflow\nT_junction = T_ambient + P_dissipated × (R_θJC + R_θCS + R_θSA) ≤ 150°C for Si"],
        ["Current derating","Derate MOSFET I_D at elevated temperature: I_D(T) ≈ I_D(25°C) × √(R_ds_on(25°C)/R_ds_on(T))\nFor parallel MOSFETs: positive temperature coefficient of R_ds_on provides current sharing"],
      ]}/>

      <h2 style={S.h2}>Protection & Fault Handling</h2>
      <Table2 rows={[
        ["Over-current protection","Hardware comparator trips gate driver within <1µs (before software can react)\nSoftware current limit: reduce duty cycle when I > I_limit before hardware trips\nCycle-by-cycle current limiting (CBC): reset PWM latch each cycle if over-current"],
        ["Shoot-through prevention","Hardware dead-time in gate driver IC prevents simultaneous conduction\nSoftware interlocks: never write complementary outputs without dead-time\nUndervoltage lockout (UVLO) in gate driver: disables outputs if V_cc < minimum"],
        ["Over-voltage protection","Occurs during regenerative braking: V_bus rises above supply\nActive clamping: crowbar switch or brake chopper dissipates excess energy in resistor\nVoltage clamp: V_bus limit triggers brake chopper at V_clamp = V_nominal × 1.1"],
        ["Under-voltage lockout","UVLO threshold: disable outputs when V_bus < minimum (e.g. <10V for 12V system)\nPrevents undefined switching behaviour during power-up/down\nHysteresis: enable threshold > disable threshold (typically 0.5–1V gap)"],
        ["Over-temperature protection","NTC thermistor on heatsink / MOSFET case read by ADC\nDerate output current linearly above T_warn (e.g. 85°C); shut down at T_max (100°C)\nJunction temperature estimation: T_j = T_case + P_loss × R_θJC"],
        ["Encoder fault detection","Position jump detection: if Δθ > threshold in one control cycle → encoder fault\nCommunication timeout: SPI encoder (AS5047) must respond within timeout window\nFallback: switch to 6-step commutation using Hall sensors if encoder fails"],
        ["Safe State / STO","STO (Safe Torque Off, IEC 61800-5-2): disables gate signals without removing power\nSIL 2 / PLd rated: two independent gate disable paths (hardware, not software)\nRequired for collaborative robots and any safety-rated servo system"],
        ["Watchdog & heartbeat","External watchdog timer resets MCU if control loop stalls\nCAN/EtherCAT heartbeat: controller must receive valid command within timeout\nFault log: non-volatile storage of fault codes for diagnostic download (UDS service 0x19)"],
      ]}/>

      <h2 style={S.h2}>Applications & System Examples</h2>
      <Table2 rows={[
        ["Electric vehicle traction","800V DC bus, SiC MOSFET inverter, 100–500 kW\nFOC with flux weakening, MTPA, active discharge, resolver feedback\nISO 26262 ASIL-D, functional safety, cybersecurity (UDS, SecOC)"],
        ["Industrial servo drive","48–400V DC bus, IGBT or MOSFET, 0.1–100 kW\nFOC position control, EtherCAT slave, STO, SIL2\nCiA 402 (CANopen) or PROFIdrive profile; >10,000 RPM capable"],
        ["Drone ESC (Electronic Speed Controller)","2–6S LiPo (7.4–25.2V), 20–100A, 20–100 kHz PWM\nSensorless BLDC 6-step or FOC; dshot digital protocol\nExtremely compact: <10g; BLHeli_32 or AM32 firmware on STM32"],
        ["CNC / 3D printer stepper driver","24–48V, microstepping up to 1/256 step\nConstant current chopper (TMC2209, DRV8825), stealthChop (spreadCycle)\nStall detection via back-EMF (stallGuard), closed-loop possible (TMC4671)"],
        ["HVAC compressor VFD","400V 3-phase AC → rectifier → DC bus → 3-phase inverter\nV/f control or sensorless FOC; soft-start; EMI filter required\nVFD = Variable Frequency Drive; IEC 61800-3 for EMC compliance"],
        ["Power steering (EPS)","12–48V, brushless or BLDC motor, 50–200A\nTorque sensor feedback, CAN communication, ASIL-C\nFunctional safety: loss of assist must be detectable and gracefully handled"],
        ["Robotics joint actuator","24–48V, PMSM + planetary gearbox, current-controlled torque\nFOC with torque loop bandwidth >1 kHz for backdrivability\nEtherCAT / UART interface; impedance control for human interaction"],
        ["Washing machine motor","230V AC, BLDC or PMSM replacing induction motor\nFOC for drum speed control (0–1800 RPM), unbalance detection\nPower factor correction in front-end rectifier; energy label A+++"],
      ]}/>

      <InfoBox title="Key Formulae Reference" items={[
        "Average voltage: V_avg = D × V_dc  (D = duty cycle 0–1)",
        "Torque: τ = K_t × I_q  (K_t in Nm/A; I_q = q-axis current in FOC)",
        "Back-EMF: V_bemf = K_e × ω  (K_e = K_t in SI units; ω in rad/s)",
        "Current ripple: ΔI = V_dc × D × (1-D) / (L × f_pwm)",
        "Switching loss: P_sw = 0.5 × V_ds × I_d × (t_r + t_f) × f_pwm",
        "Conduction loss: P_cond = I_rms² × R_ds_on (MOSFET) or I_avg × V_ce (IGBT)",
        "Junction temperature: T_j = T_amb + P_total × (R_θJC + R_θCS + R_θSA)",
        "Electrical time constant: τ_e = L_a / R_a",
        "Mechanical time constant: τ_m = J × R_a / K_t²",
        "Flux weakening voltage limit: √(Vd² + Vq²) ≤ V_dc / √3",
        "FOC Clark: I_α = I_a;  I_β = (I_a + 2I_b) / √3",
        "FOC Park: I_d = I_α·cos(θ) + I_β·sin(θ);  I_q = −I_α·sin(θ) + I_β·cos(θ)",
      ]}/>
    </div>
  );
}